import React from 'react';
import Counter from './Counter';

const LiveDemo = () => {
  return (
    <section id="live-demo" className="section">
      <div className="container">
        <h2>Live Demo Project: Counter App</h2>
        <p className="section-subtitle">
          This is a tiny project included in the same codebase. You can use this pattern
          to add more embedded apps or move them into their own paths/subdomains.
        </p>

        <div className="demo-card">
          <h3>Counter</h3>
          <p className="demo-description">
            Click the buttons to interact with the counter. This is powered by a few lines of React.
          </p>

          <Counter />
        </div>
      </div>
    </section>
  );
};

export default LiveDemo;
